module.exports = __webpack_public_path__ + "img/main.b4885072.jpg";